<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="toc-ttl" id="toc">Contents</p>
<p class="toc-tx1"><a href="#/c4#title">TITLE PAGE</a></p>
<p class="toc-tx1"><a href="#/c5#copy">COPYRIGHT PAGE</a></p>
<p class="toc-tx1" id="ack1"><a href="#/c8#ack">ACKNOWLEDGMENTS</a></p>
<p class="toc-tx1" id="toc1"><a href="#/c9#ch1">CHAPTER ONE</a></p>
<p class="toc-tx1" id="toc2"><span href="#/c10#ch2" title="Link target outside of Sample">CHAPTER TWO</span></p>
<p class="toc-tx1" id="toc3"><span href="#/c11#ch3" title="Link target outside of Sample">CHAPTER THREE</span></p>
<p class="toc-tx1" id="toc4"><span href="#/c12#ch4" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p class="toc-tx1" id="toc5"><span href="#/c13#ch5" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="toc-tx1" id="toc6"><span href="#/c14#ch6" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="toc-tx1" id="toc7"><span href="#/c15#ch7" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="toc-tx1" id="toc8"><span href="#/c16#ch8" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="toc-tx1" id="toc9"><span href="#/c17#ch9" title="Link target outside of Sample">CHAPTER NINE</span></p>
<p class="toc-tx1" id="toc10"><span href="#/c18#ch10" title="Link target outside of Sample">CHAPTER TEN</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c7.vue?023c9b4b